import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const useArchiveReports = () => {
  const dispatch = useDispatch();
  const { fetchTableData, searchQuery } = useSelector(
    (state) => state.archiveReport
  );

  const [sorting, setSorting] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  return {
    search: searchQuery,
    pagination,
    sorting,
    dispatch,
    fetchTableData,
    setPagination,
    setSorting,
  };
};

export default useArchiveReports;
